import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import enTranslations from './locale/en.json';
import esTranslations from './locale/es.json';

// Initialize i18next
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    es: {
      translation: esTranslations,
    },
  },
  lng: 'en', // default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  // Added these options for better development experience
  debug: import.meta.env.VITE_ENV === 'development',
  react: {
    useSuspense: false, // This prevents the app from freezing while loading translations
  },
});

export default i18n;
